<div class="container-fluid header-container">
  <div class="row kc-row-header min-h80 align-items-center">
    <div class="col-sm-5">
      <!-- client detail header -->
      <div class="cliendbadge-container" *ngIf="!showBillingInfo">
        <div *ngIf="showContactInfo">
          <div class="dropdown">
            <div class="dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" (click)="refreshClientData();">
              <div class="cliendbadge-container-left">
                <div class="clientbadge-circle" [ngStyle]="{'background-color':clientBackgroundColor,'color': clientTextColor }" *ngIf="imageSource == null || imageSource ==''">
                  {{clientShortName}}
                </div>
                <div class="clientbadge-circle-image" *ngIf="imageSource !=null && imageSource !=''">
                  <img [src]="imageSource" alt="image" class="circle-img"  loading="lazy"/>
                </div>
              </div>
              <div class="cliendbadge-container-right">
                <span class="cliendbadge-name">
                  {{clientName}}
                </span>
                <span class="cliendbadge-type">{{clientEntityType}}</span>
              </div>
            </div>
            <div class="dropdown-menu cliendbadge-dropdownbox">
              <div class="custom-row">
                <div class="col-3">
                  <div class="cliendbadge-dropdownbox-left">
                    <img [src]="imageSource" alt="image" class="cliendbadge-profile-image" *ngIf="imageSource !=null && imageSource !=''"  loading="lazy"/>
                    <div class="" *ngIf="imageSource == null || imageSource ==''">
                      <div class="cliendbadge-profile-circle" [ngStyle]="{'background-color':clientBackgroundColor,'color': clientTextColor }">{{clientShortName}}</div>
                    </div>
                  </div>
                </div>
                <div class="col-9">
                  <div class="cliendbadge-dropdownbox-right">
                    <div class="cliendbadge-dropdownbox-right-row">
                      <h6>Contact</h6>
                      <div class="dropdownbox-right-row-item">
                        <label class="dropdownbox-row-item-label">
                          Work
                        </label>
                        <p class="dropdownbox-row-item-value ellipsis-email-text">
                          <a href="mailto:{{emailstring1}}" title="{{emailstring1}}" class="" *ngIf="emailstring1!=null && emailstring1!='' && emailbookmark1">{{emailstring1}}</a>
                          <a href="mailto:{{emailstring2}}" title="{{emailstring2}}" *ngIf="emailstring2!=null && emailstring2!='' && emailbookmark2">{{emailstring2}}</a>
                          <a href="mailto:{{emailstring3}}" title="{{emailstring3}}" *ngIf="emailstring3!=null && emailstring3!='' && emailbookmark3">{{emailstring3}}</a>
                        </p>
                      </div>
                      <div class="dropdownbox-right-row-item">
                        <label class="dropdownbox-row-item-label">
                          Phone
                        </label>
                        <p class="dropdownbox-row-item-value">
                          <span class="" *ngIf="phonestring1!=null && phonestring1!='' && phonebookmark1">{{phonestring1}}</span>
                          <span class="" *ngIf="phonestring2!=null && phonestring2!='' && phonebookmark2">{{phonestring2}}</span>
                          <span class="" *ngIf="phonestring3!=null && phonestring3!='' && phonebookmark3">{{phonestring3}}</span>
                        </p>
                      </div>
                    </div>
                    <div class="cliendbadge-dropdownbox-right-row">
                      <h6>About</h6>
                      <div class="dropdownbox-right-row-item">
                        <label class="dropdownbox-row-item-label">
                          DOB
                        </label>
                        <p class="dropdownbox-row-item-value" *ngIf="clientDataModal.dateofbirth !='0001-01-01T00:00:00' && clientDataModal.dateofbirth != null && clientDataModal.dateofbirth != undefined">
                          {{clientDataModal.dateofbirth | date:'dd/MM/yyyy'}}
                        </p>
                      </div>
                      <div class="dropdownbox-right-row-item">
                        <label class="dropdownbox-row-item-label">
                          Employer
                        </label>
                        <p class="dropdownbox-row-item-value">
                          {{clientDataModal.companyName}}
                        </p>
                      </div>
                      <div class="dropdownbox-right-row-item">
                        <label class="dropdownbox-row-item-label">
                          Address
                        </label>
                        <p class="dropdownbox-row-item-value">
                          <span class="" *ngIf="clientDataModal.physicaladdressline1 !=null && clientDataModal.physicaladdressline1 !=''">
                            {{clientDataModal.physicaladdressline1}},
                          </span>
                          <span class="" *ngIf="clientDataModal.physicaladdressline2 !=null && clientDataModal.physicaladdressline2 !=''">
                            {{clientDataModal.physicaladdressline2}},
                          </span>
                          <span class="" *ngIf="clientDataModal.physicalsuburb !=null && clientDataModal.physicalsuburb !=''">
                            {{clientDataModal.physicalsuburb}},
                          </span>
                          <span class="" *ngIf="clientDataModal.stateName !=null && clientDataModal.stateName !=''">
                            {{clientDataModal.stateName}},
                          </span>
                          <span class="" *ngIf="clientDataModal.physicalpostcode !=null && clientDataModal.physicalpostcode !=''">
                            {{clientDataModal.physicalpostcode}},
                          </span>
                          <span class="" *ngIf="clientDataModal.countryName !=null && clientDataModal.countryName !=''">
                            {{clientDataModal.countryName}}
                          </span>
                        </p>
                      </div>
                      <div class="dropdownbox-right-row-item">
                        <label class="dropdownbox-row-item-label">
                          ABN
                        </label>
                        <p class="dropdownbox-row-item-value">
                          {{clientDataModal.abn}}
                        </p>
                      </div>
                    </div>
                    <div class="cliendbadge-dropdownbox-right-row" *ngIf="clientDataModal.cFirstName !=undefined || emailstring4 !=undefined || phonestring4 !=undefined">
                      <h6>Contact</h6>
                      <div class="dropdownbox-right-row-details">
                        <div class="dropdownbox-right-row-details-left">
                          <img hidden alt="image" src="../assets/img/client-profile/user-icon.jpg" class="contact-circle-img" *ngIf="clientDataModal.cContactSortName == undefined || clientDataModal.cContactSortName == null || clientDataModal.cContactSortName == ''"  loading="lazy"/>
                          <div class="" *ngIf="clientDataModal.cContactSortName != undefined && clientDataModal.cContactSortName != null && clientDataModal.cContactSortName != ''">
                            <span class="dropdownbox-contact-circle">{{clientDataModal.cContactSortName}}</span>
                          </div>
                        </div>
                        <div class="dropdownbox-right-row-details-right">
                          <span class="dropdownbox-details-name">{{clientDataModal.cFirstName}} {{clientDataModal.cLastName}}</span>
                          <p class="dropdownbox-details-email">
                            <a href="mailto:{{emailstring4}}" class="ellipsis-email-text" title="{{emailstring4}}">
                              <img alt="" src="../assets/img/client-profile/email_icon.svg" class="" loading="lazy"> {{emailstring4}}
                            </a>
                          </p>
                          <p class="dropdownbox-details-number"><img alt="" src="../assets/img/client-profile/phone_icon.svg" class="" loading="lazy"> +{{phonestring4}}</p>
                        </div>
                      </div>
                    </div>
                    <div class="cliendbadge-dropdownbox-right-row" *ngIf="relationships1 != undefined && relationships1 != null && relationships1.length > 0">
                      <h6>Related Parties</h6>
                      <div class="dropdownbox-right-row-details">
                        <div class="dropdownbox-right-row-details-left">
                          <img hidden alt="" src="../assets/img/client-profile/user-icon.jpg" class="contact-circle-img" loading="lazy"/>
                          <div class="">
                            <span class="dropdownbox-contact-circle">{{relationships1[0].clientSortName}}</span>
                          </div>
                        </div>
                        <div class="dropdownbox-right-row-details-right">
                          <span class="dropdownbox-details-name">{{relationships1[0].clientName}}</span>
                          <p class="dropdownbox-details-email">
                            <a href="mailto:{{relationships1[0].emailaddress}}" class=" ellipsis-email-text" title="{{relationships1[0].emailaddress}}">
                              <img alt="" src="../assets/img/client-profile/email_icon.svg" class="" loading="lazy"/>
                              {{relationships1[0].emailaddress}}
                            </a>
                          </p>
                          <p class="dropdownbox-details-number">
                            <img alt="" src="../assets/img/client-profile/phone_icon.svg" class="" loading="lazy"/>
                            +{{relationships1[0].phonenumber}}
                          </p>
                        </div>
                      </div>
                    </div>
                    <div class="cliendbadge-dropdownbox-right-row" *ngIf="defaultflag == true && weburl != undefined && weburl.weburl != ''">
                      <h6>Linked Software</h6>
                      <div class="dropdownbox-right-row-item">
                        <a class="linked-software-icon" href="{{weburl.weburl}}" target="_blank">
                          <img src="../../../assets/img/xeroIcons/XeroImage.png" class="" loading="lazy"/>
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- client detail header end-->
      <div class="bg-white billing-tab-title d-flex header-css pt-4" *ngIf="false">
        <div class="col-sm-12 tab-titlses-wrap cmn-tabs-design">
          <div class="col-sm-12 profile-head px-3">
            <ul class="nav nav-tabs mt-2" id="myTab" role="tablist">
              <li class="nav-item cusr-kc" (click)="isWipDisable ? null : wipshow()" *ngIf="IsWIPView">
                <a class="nav-link active wiptab" id="wip-tab" data-cy="WipTab" data-bs-toggle="tab" role="tab" aria-controls="activity" aria-selected="false">WIP</a>
              </li>
              <li class="nav-item cusr-kc invoicetab px-3" (click)="isInvoiceDisable ? null : invoiceshow()" *ngIf="IsinvoicesView">
                <a class="nav-link" id="invoice-tab" data-cy="InvoiceTab" data-bs-toggle="tab" role="tab" aria-controls="activity" aria-selected="false">Invoices</a>
              </li>
              <li class="nav-item cusr-kc invoicetab" (click)="isPlannedInvoiceDisable ? null : plannedinvoiceshow()" *ngIf="IsPlannedinvoicesView">
                <a class="nav-link" id="planned-invoice-tab" data-cy="PlannedInvoiceTab" data-bs-toggle="tab" role="tab" aria-controls="activity" aria-selected="false">Planned invoices</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="bg-white billing-tab-title d-flex header-css pt-4" *ngIf="showClientList">
        <div class="col-sm-12 tab-titlses-wrap cmn-tabs-design">
          <div class="col-sm-12 profile-head px-3">
            <ul class="nav nav-tabs mt-2" id="myTab" role="tablist">  
              <li class="nav-item cusr-kc px-2" (click)="showclientlist('clientlist')">
                <a class="nav-link active clienttab" href="/client/clientlist" [ngClass]="{'active': clientCurrentTab == 'client'}" data-cy="cyclientList" id="wip-tab" data-bs-toggle="tab" role="tab" aria-controls="activity" aria-selected="false">Clients</a>
              </li>
              <li class="nav-item cusr-kc invoicetab px-2" (click)="showclientlist('groups')">
                <a class="nav-link" href="/client/groups" [ngClass]="{'active': clientCurrentTab == 'groups'}"  data-cy="cyGroups" id="invoice-tab" data-bs-toggle="tab" role="tab" aria-controls="activity" aria-selected="false">Groups</a>
              </li>
              <li class="nav-item cusr-kc invoicetab px-2" (click)="showclientlist('contacts')">
                <a class="nav-link" href="/client/contacts" [ngClass]="{'active': clientCurrentTab == 'contacts'}" data-cy="cyContacts" id="invoice-tab" data-bs-toggle="tab" role="tab" aria-controls="activity" aria-selected="false">Contacts</a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="bg-white billing-tab-title d-flex header-css pt-4" *ngIf="showClientClassic">
        <div class="col-sm-12 tab-titlses-wrap cmn-tabs-design">
          <div class="col-sm-12 profile-head px-3">
            <ul class="nav nav-tabs mt-2" id="myTab" role="tablist">
              <li class="nav-item cusr-kc px-2" (click)="showclientlist('client-classic')">
                <a class="nav-link" href="/client/client-classic" [ngClass]="{'active': clientCurrentTab == 'clientClassic'}" data-cy="cyclientList" id="wip-tab" data-bs-toggle="tab" role="tab" aria-controls="activity" aria-selected="false">Clients Classic</a>
              </li>
              <li class="nav-item cusr-kc invoicetab px-2" (click)="handleClientClassicNavigation('groups')">
                <a class="nav-link" href="/client/client-classic/groups" [ngClass]="{'active': clientCurrentTab == 'groups'}"  data-cy="cyGroups" id="invoice-tab" data-bs-toggle="tab" role="tab" aria-controls="activity" aria-selected="false">Groups</a>
              </li>
              <li class="nav-item cusr-kc invoicetab px-2" (click)="handleClientClassicNavigation('contacts')">
                <a class="nav-link" href="/client/client-classic/contacts" [ngClass]="{'active': clientCurrentTab == 'contacts'}" data-cy="cyContacts" id="invoice-tab" data-bs-toggle="tab" role="tab" aria-controls="activity" aria-selected="false">Contacts</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

     
      
    <div class="col-sm-7">
      <nav class="navbar navbar-expand navbar-light bg-white topbar static-top shadow topbar-head">
        <div class="ml-auto">
          <div class="global-search-wrapper col-sm-12 pl-0 pr-0">
            <button class="global-search-trigger no-mat-effect col-sm-12 pl-0 pr-0">
              <img src="../../../assets/img/search-icon/search_icon.svg" class="search-icon-cmd" />
              <input #searchInput placeholder="Search client name / client code / client group / email / phone"
                     [(ngModel)]="searchText" [matAutocomplete]="auto" (input)="onSearch()" (click)="toggleAuto()" (keydown.enter)="onEnter()" />
              <img src="../../../assets/img/ArrowBlueIcon/Remove normal state.svg" width="10" height="10" class="remove-icon-text-cmd" alt="removeIcon"
                   *ngIf="searchText" (click)="clearSearch($event)" />
            </button>
            <mat-autocomplete #auto="matAutocomplete" class="global-search-menu" (opened)="isOpen = true"
                              (closed)="isOpen = false" panelWidth="800px">
              <div class="search-tabs">
                <span *ngFor="let tab of tabs" [class.active]="activeTab === tab"
                      (click)="onTabChange(tab); $event.stopPropagation()">
                  {{ tab }}
                </span>
              </div>
              <div class="height-drodown">
                <!--<div class="section-title">Recent search</div>-->
                <ng-container *ngIf="showSection('Clients')">
                  <div class="section-title" *ngIf="filteredClients.length">
                    Clients
                  </div>
                  <!-- RESULTS -->
                  <mat-option *ngFor="let c of filteredClients" (click)="openSameTab(c)">
                    <div class="result-item d-flex justify-content-between">
                      <div class="d-flex justify-content-start">
                        <!-- <div class="avatar">{{ c.initials }}</div> -->
                        <div class="details">
                          <div class="d-flex justify-content-start">
                            <div class="contact-name-text ellipsis name-width-cmd" title="{{c.name}}" [innerHTML]="highlight(c.name, c, false)"></div>
                            <div class="ml-1 mr-1" *ngIf="c.name && (c.code || c.groupname)">|</div>
                            <div class="sub-rext-cmd ellipsis group-content-width" [title]="getCodeGroup(c)" [innerHTML]="highlight(getCodeGroup(c), c, false)"></div>
                          </div>

                          <div class="d-flex justify-content-start">
                            <div class="contact-name-text ellipsis d-flex justify-content-start" *ngIf="c.email">

                              <img src="../../../assets/img/addclient/email-grey-outline.svg" class="mr-1 email-phone-icon" />
                              <span class="email-type mr-1" *ngIf="c.emailType" [title]="c.emailType">
                                {{ c.emailType.charAt(0).toUpperCase() }}:
                              </span>
                              <span class="ellipsis email-width-cmd" [title]="c.email" [innerHTML]="highlight(c.email, c, false)"></span>
                            </div>

                            <div class="ml-1" *ngIf="c.email && c.phone">|</div>

                            <div class="contact-name-text ellipsis d-flex justify-content-start" *ngIf="c.phone">

                              <img src="../../../assets/img/addclient/phone-grey-outline.svg" class="ml-1 mr-1 email-phone-cmd-icon" /> <span [innerHTML]="highlight(c.phone, c, true)"></span>

                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="mr-top-cmd-quick" (click)="openNewTab(c); $event.stopPropagation()">

                        <img src="../../../assets/img/ArrowBlueIcon/Icon.svg" width="12px" title="Open in new tab" />

                      </div>
                    </div>
                  </mat-option>
                  <!-- NO RECORD (Clients tab only) -->

                  <mat-option class="no-records-option"
                              *ngIf="hasSearched && searchText && activeTab === 'Clients' && filteredClients.length === 0">
                    <div class="no-records">No records found</div>
                  </mat-option>
                </ng-container>
                <div class="global-search-divider"
                     *ngIf="activeTab === 'All'
           && filteredClients.length
           && (filteredGroups.length || filteredContacts.length)">
                </div>


                <ng-container *ngIf="showSection('Groups')">
                  <div class="section-title" *ngIf="filteredGroups.length">
                    Client groups
                  </div>

                  <mat-option *ngFor="let g of filteredGroups" (click)="openSameTab(g)">
                    <div class="result-item d-flex justify-content-between">
                      <div class="d-flex justify-content-start">
                        <!-- <div class="avatar">{{ g.initials }}</div> -->
                        <div class="details">
                          <div class="d-flex justify-content-start">
                            <div class="contact-name-text ellipsis name-width-cmd" title="{{g.name}}" [innerHTML]="highlight(g.name, g, false)"></div>
                            <div class="ml-1 mr-1" *ngIf="g.name && (g.code || g.groupname)">|</div>
                            <div class="sub-rext-cmd ellipsis group-content-width" [title]="getCodeGroup(g)" [innerHTML]="highlight(getCodeGroup(g), g, false)"></div>
                          </div>

                          <div class="d-flex justify-content-start">

                            <div class="contact-name-text d-flex justify-content-start" *ngIf="g.email">
                              <img src="../../../assets/img/addclient/email-grey-outline.svg"
                                   class="mr-1 email-phone-icon" alt="email" />
                              <span class="email-type mr-1" *ngIf="g.emailType" [title]="g.emailType">
                                {{ g.emailType.charAt(0).toUpperCase() }}:
                              </span>
                              <span [innerHTML]="highlight(g.email, g, false)" title="{{g.email}}" class="ellipsis email-width-cmd"></span>
                            </div>

                            <div class="ml-1" *ngIf="g.email && g.phone">|</div>

                            <div class="contact-name-text d-flex justify-content-start" *ngIf="g.phone">
                              <img src="../../../assets/img/addclient/phone-grey-outline.svg"
                                   class="ml-1 mr-1 email-phone-cmd-icon" alt="phone" /><span [innerHTML]="highlight(g.phone, g, true)"></span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mr-top-cmd-quick" (click)="openNewTab(g); $event.stopPropagation()">
                        <img src="../../../assets/img/ArrowBlueIcon/Icon.svg" width="12px" class="ml-1" title="Open in new tab">
                      </div>
                    </div>
                  </mat-option>

                  <mat-option class="no-records-option" *ngIf="hasSearched && searchText &&
   activeTab === 'Groups' &&
   filteredGroups.length === 0">
                    <div class="no-records">No records found</div>
                  </mat-option>
                </ng-container>
                <div class="global-search-divider"
                     *ngIf="activeTab === 'All'
                && filteredGroups.length
                 && filteredContacts.length">
                </div>



                <ng-container *ngIf="showSection('Contacts')">
                  <div class="section-title" *ngIf="filteredContacts.length">
                    Contacts
                  </div>

                  <mat-option *ngFor="let c of filteredContacts" (click)="openSameTab(c)">
                    <div class="result-item d-flex justify-content-between">
                      <div class="d-flex justify-content-start">
                        <!-- <div class="avatar">{{ c.initials }}</div> -->
                        <div class="details">

                          <div class="contact-name-text ellipsis width-contact-name" title="{{c.name}}" [innerHTML]="highlight(c.name, c, false)"></div>
                          <div class="d-flex justify-content-start">
                            <div class="contact-name-text d-flex justify-content-start" *ngIf="c.email">
                              <img src="../../../assets/img/addclient/email-grey-outline.svg"
                                   class="mr-1 email-phone-icon" alt="email" />
                              <span class="email-type mr-1" *ngIf="c.emailType" [title]="c.emailType">
                                {{ c.emailType.charAt(0).toUpperCase() }}:
                              </span>
                              <span [innerHTML]="highlight(c.email, c, false)" [title]="c.email" class="ellipsis email-width-cmd"></span>
                            </div>
                            <div class="ml-1" *ngIf="c.email && c.phone">|</div>
                            <div class="contact-name-text d-flex justify-content-start" *ngIf="c.phone">
                              <img src="../../../assets/img/addclient/phone-grey-outline.svg"
                                   class="ml-1 mr-1 email-phone-cmd-icon" alt="phone" /> <span [innerHTML]="highlight(c.phone, c, true)"></span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mr-top-cmd-quick" (click)="openNewTab(c); $event.stopPropagation()">
                        <img src="../../../assets/img/ArrowBlueIcon/Icon.svg" width="12px" class="ml-1" title="Open in new tab">
                      </div>

                    </div>
                  </mat-option>
                  <mat-option class="no-records-option" *ngIf="hasSearched && searchText &&
   activeTab === 'Contacts' &&
   filteredContacts.length === 0">
                    <div class="no-records">No records found</div>

                  </mat-option>
                </ng-container>
                <ng-container>
                  <mat-option class="no-records-option" *ngIf="searchText &&
       activeTab === 'All' &&
       filteredClients.length === 0 &&
       filteredGroups.length === 0 &&
       filteredContacts.length === 0">
                    <div class="no-records">
                      No records found
                    </div>
                  </mat-option>
                </ng-container>
              </div>
            </mat-autocomplete>
          </div>

        </div>
        <ul class="navbar-nav">
          <li class="nav-item dropdown no-arrow mx-1">
            <a class="nav-link dropdown-toggle" href="#" id="alertsDropdown" role="button" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false" (click)="checkflag();">
              <img class="img-responsive" src="../assets/img/header-icon/plus_top.svg" alt="" loading="lazy" />
            </a>
            <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in quick-popup" aria-labelledby="messagesDropdown">
              <ul>
                <li>
                  <span class="quickmenuHeader">Client</span>
                </li>
                <li>
                  <a class="dropdown-item d-flex align-items-center panel-item" (click)="tempload = 1; openModal(createclientModalPopup, 'modal-lg','createclientModalPopup')" *ngIf="IsclientAdd">
                    Add client/prospect
                  </a>
                </li>
                <li>
                  <a class="dropdown-item d-flex align-items-center panel-item" (click)="OpenCreatecontactPopup()">
                    Add contact
                  </a>
                </li>
                <li>
                  <span class="quickmenuHeader">Workflow</span>
                </li>
                <li>
                  <a class="dropdown-item d-flex align-items-center panel-item" (click)="openModal(createjobModalPopup, 'modal-lg cmn-createjob-Popup-Ui', 'createjobModalPopup'); isAddJob = 1; Contactpage = 'headerpage'" *ngIf="isJobAdd">
                    Add job
                  </a>
                </li>
                <li>
                  <span class="quickmenuHeader">Timesheet</span>
                </li>
                <li>
                  <a class="dropdown-item d-flex align-items-center panel-item" (click)="openModal(quickAddTimelogModalPopup, 'modal-lg','quickAddTimelogModalPopup')">
                    Add time
                  </a>
                </li>
                <li>
                  <span class="quickmenuHeader">Billing</span>
                </li>
                <li>
                  <button type="button" class="dropdown-item" (click)="openDisbursementPopup()">
                    Add disbursement
                  </button>
                </li>
                <!-- SharePoint Developer:  Dev: Sandesh ; Date: 21-03-2025,  Sharepoint  -->
                <li *ngIf="_dmsPType === 'SharePoint' && permissions.isAddDocuments  && permissions.isViewDocuments">
                  <span class="quickmenuHeader">Document</span>
                </li>
                <li *ngIf="_dmsPType === 'SharePoint' && permissions.isFileTemplate && permissions.isAddDocuments  && permissions.isViewDocuments">
                  <a class="dropdown-item d-flex align-items-center panel-item" (click)="openModal(CreateDocTemplateModal, 'modal-md cmn-createDocTemplate-Popup-UI','createDocTemplate')">
                    Create
                  </a>
                </li>
                <li *ngIf="_dmsPType === 'SharePoint' && permissions.isViewDocuments && (permissions.isAddDocuments || permissions?.isManageDocuments || permissions?.isManageFolders)">
                  <button type="button" class="dropdown-item panel-item" (click)="openGlobalUploadPopup(globalUploadFilesPopup)">
                    Upload
                  </button>
                </li>
                <li *ngIf="_dmsPType !== 'SharePoint'">
                  <span class="quickmenuHeader">Document</span>
                </li>
                <li *ngIf="_dmsPType !== 'SharePoint'">
                  <button type="button" class="dropdown-item" (click)="openModal(addImanageDocPopup, 'modal-md add-imanage-popup-container','addImanageDocPopup')">Create</button>
                </li>
              </ul>
            </div>
          </li>
          <!-- Nav Item - Alerts -->
          <li class="nav-item dropdown no-arrow mx-1">

            <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="alertsDropdown">
              <h6 class="dropdown-header notification-header">
                User Notification<span class="notification-new">2 new</span>
              </h6>
              <div class="row kc-row">
                <div class="col-md-2"><span class="alert alert-active">Alert</span></div>
                <div class="col-md-2"><span class="alert">Events</span></div>
                <div class="col-md-2"><span class="alert">Logs</span></div>
              </div>
              <a class="dropdown-item d-flex align-items-center" href="#">
                <div class="dropdown-list-image">
                  <div class="dropdown-list-image">
                    <img src="../../../assets/img/header-icon/avatar.svg" class="img-responsive quick-img" alt="" loading="lazy" />
                  </div>
                </div>
                <div>
                  <span class="font-weight-bold">New Client Has Been Allocated</span>
                  <div class="small text-gray-500">2hrs ago</div>
                </div>
              </a>
              <a class="dropdown-item d-flex align-items-center" href="#">
                <div class="dropdown-list-image">
                  <div class="dropdown-list-image">
                    <img src="../../../assets/img/header-icon/avatar.svg" class="img-responsive quick-img" alt="" loading="lazy" />
                  </div>
                </div>
                <div>
                  <span class="font-weight-bold">New Client Has Been Allocated</span>
                  <div class="small text-gray-500">2hrs ago</div>
                </div>
              </a>
              <a class="dropdown-item d-flex align-items-center" href="#">
                <div class="dropdown-list-image">
                  <div class="dropdown-list-image">
                    <img src="../../../assets/img/header-icon/clipboards.svg" class="img-responsive quick-img" alt="" loading="lazy" />
                  </div>
                </div>
                <div>
                  <span class="font-weight-bold">New Client Has Been Allocated</span>
                  <div class="small text-gray-500">2hrs ago</div>
                </div>
              </a>
              <a class="dropdown-item d-flex align-items-center" href="#">
                <div class="dropdown-list-image">
                  <div class="dropdown-list-image">
                    <img src="../../../assets/img/header-icon/cashback.svg" class="img-responsive quick-img" alt="" loading="lazy" />
                  </div>
                </div>
                <div>
                  <span class="font-weight-bold">New Client Has Been Allocated</span>
                  <div class="small text-gray-500">2hrs ago</div>
                </div>
              </a>

            </div>
          </li>
          <!-- Nav Item - Messages -->
          <li class="nav-item dropdown no-arrow mx-1">
            <a class="nav-link dropdown-toggle" href="#" id="messagesDropdown" role="button" [matBadge]="this.Ncount" matBadgeColor="warn" data-bs-toggle="dropdown" (click)="GetNotifications()" aria-haspopup="true" aria-expanded="false">
              <img class="img-responsive bellIcon" src="../assets/img/header-icon/bell_icon.svg" alt="" loading="lazy" />
            </a>
            <!-- Dropdown - Messages -->
            <div class="dropdown-list dropdown-menu dropdown-menu-right shadow animated--grow-in" aria-labelledby="messagesDropdown">
              <div class="col-sm-12 p-0">
                <div class="notification_header shadow-sm">
                  <span class="kc-notifications">Notification</span>
                </div>
                <div class="fixTableHead">
                  <div *ngFor="let _obj of _lstNotifications; let i = index;">
                    <div class="row kc-row billing-row mt-4 bottom_kc_notification" *ngIf="_obj.isgroupby == 1">
                      <div class="col-sm-4 mb-2" (click)="NavigatetoPage(_obj.type, _obj.commonid,_obj.assignedTo,_obj.timesheetDate,_obj.isTimesheetPublished);MarkasRead(_obj.notificationId,$event,1,i);">
                        <span class="kc-date text_fomrmation_test">{{_obj.duration}}</span>
                      </div>
                      <div class="col-sm-1 mb-2">
                        &nbsp;
                      </div>
                      <div class="col-sm-6 pr-3 mb-2 d-flex justify-content-end">
                        <p>
                          <span class="kc-clear kc-blue-clr" style="cursor:pointer" (click)="MarkAllAsRead();">Mark all as read</span>&nbsp; <span class="vertical-line2"></span>&nbsp;
                          <span class="kc-clear kc-blue-clr" style="cursor:pointer" (click)="ClearNotifications(_obj.notificationId)">Clear</span>
                        </p>
                      </div>
                    </div>
                    <div class="row kc-row kc-today" [ngClass]="{'kc-notfi-done':_obj.status=='Completed','kc-notfi-open':_obj.status=='Open'}">
                      <div class="col-sm-10 pr-0" (click)="NavigatetoPage(_obj.type, _obj.commonid,_obj.assignedTo,_obj.timesheetDate,_obj.isTimesheetPublished);MarkasRead(_obj.notificationId,$event,1,i);"> <!--// Developer: Ramya;  Ticket: CUST-1045;  Date: 29-Apr-2022-->
                        <a class="dropdown-item d-flex align-items-center">
                          <div class="dropdown-list-image">
                            <div class="profile_name_cicrle" title="{{_obj.fullName}}">{{_obj.sName}}</div>
                          </div>
                          <div class="font-weight-bold">
                            <div class="text-truncate">
                              <a class="timesheet-tooltip" data-bs-toggle="tooltip" data-placement="top" title="{{_obj.notificationText}}​​">
                                <span class="kc-timesheet-letterStatus font_size_kc_001" [ngClass]="{'kc-timesheet-letterStatus ':_obj.status=='Completed','kc-timesheet-letterStatus1':_obj.status=='Open'}">{{_obj.notificationText}}</span>
                              </a>
                            </div>
                            <div class="small text-gray-500 mt-1" *ngIf="_obj.notificationDetails!=''">
                              <span class="kc-not-del font-size_blue_kc">{{_obj.notificationDetails}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                            </div>
                            <div class="small text-blue-500 kc-time-hr mt-2 "><span *ngIf="_obj.duration == 'Today' " class="kc-not-hr font_size_kc_test">{{_obj.durationinhours}}</span><span *ngIf="_obj.duration != 'Today'  " class="kc-not-hr font_size_kc_test">{{_obj.createdDate  + 'Z'| date:'EEEE dd/MM/yyyy h:mm a'}}</span></div>
                          </div>
                        </a>
                      </div>
                      <div class="col-sm-2 d-flex justify-content-center">
                        <div class="kc-remind timenarbutton position-absolute">
                          <img class="img-responsive remind-img bg_color_timer_kc" src="../../../assets/img/NotificationIocns/TimerNewIcon.svg" alt="" (click)="openModal(SetReminderModalPopup, 'modal-md reminder_popup');SetNotificationId(_obj.notificationId);" loading="lazy" />&nbsp;&nbsp;&nbsp;
                          <div *ngIf="_obj.markasRead==true" (click)="MarkasRead(_obj.notificationId,$event,1,i)" title="Mark as read​​">
                            <input type="radio" class="mb-3 radio_button_css" name="radio-{{i}}" [checked]="true" />&nbsp;
                          </div>
                          <div *ngIf="_obj.markasRead==false" (click)="MarkasRead(_obj.notificationId,$event,0,i)" title="Mark as unread​​">
                            <input type="radio" class="mb-3 radio_button_css" name="radio-{{i}}" [checked]="false" />&nbsp;
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                <div class="d-flex justify-content-center small text-gray-500 kc-notifi show_notification_status-kc" (click)="OpenErrorMsgnotify()">
                  <span class="kc-show-all mr_top_kc_css">Show all Notifications</span>
                </div>
              </div>
            </div>
          </li>
          <!-- help icon UI -->
          <li class="nav-item">
            <button class="quickhelp-btn" type="button" (click)="goToLink()" matTooltipClass="cmn-tooltip-template" matTooltip="Help & Support">
              <img class="img-responsive" src="../assets/img/header-icon/help-icon.svg" alt="icon" loading="lazy" />
            </button>
          </li>
          <!-- help icon UI end -->
          <li class="nav-item dropdown no-arrow">
            <a class="nav-link dropdown-toggle pl-0 pr-1 pr-xl-2  profile-Dropdown-Btn" id="userDropdown" role="button">
              <div class="dot kc-client-name end-icon" [ngStyle]="{'background-color':getBackgroundColour(),'color':getTextColour(),'top':'1px','left':'0'}" data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="true" title="{{ userFullName }}"> {{getShortName()}} </div>
              <div class="logindropdown">
                <ul class="changepsw-dropmenu  dropdown-menu dropdown-menu-right dropdwn-menu">
                  <li>
                    <button class="dropdown-item kc-client-dropdown-item " (click)="openuserprofile()">
                      <span class="profile-menu-icon">
                        <img src="../../../assets/img/user-menu.svg" alt="icon" loading="lazy" />
                      </span>
                      User Profile
                    </button>
                  </li>
                  <li>
                    <button class="dropdown-item kc-client-dropdown-item " (click)="changepsw()">
                      <span class="profile-menu-icon">
                        <img src="../../../assets/img/header-icon/change-pass.svg" alt="icon" loading="lazy" />
                      </span>
                      Change Password
                    </button>
                  </li>
                  <li>
                    <button class="dropdown-item kc-client-dropdown-item" (click)="logoutB2C()">
                      <span class="profile-menu-icon">
                        <img src="../../../assets/img/header-icon/logout.svg" alt="icon" loading="lazy" />
                      </span>
                      Logout
                    </button>
                  </li>
                </ul>
              </div>
            </a>
          </li>
        </ul>
      </nav>
    </div>
    </div>
  </div>

<!--RemindMe Popup Start-->
<ng-template #SetReminderModalPopup>
  <form class="times-log-form">
      <div class="col-sm-12 p-0 tmslog">
          <div class="modal-content modal-content_data_fliter border_radies_filter_popup">
            <div class="col-sm-12">
              <div class="mt-3">
                <h4 class="model_color_filter kc-modal-title1">Set Reminder</h4>
              </div>
            </div>
            <div class="bottom_Line_fliter_line"></div>
            <div class="col-sm-12">
              <div class="col-sm-12">
                <div class="mt-2">
                  <span class="filter_name-css">Select Time</span>
                </div>
                <div class="kc-reminder custom-radio-dsgn"><input class="check_css check_css1 custom-radio" name="radio" id="fifteenmin" type="radio" (change)="SetReminderValue(1,$event)" value=""><span class="radio-circle"></span>&nbsp;&nbsp;<label class="kc-time kc-form-label" for="fifteenmin">15 Minutes</label></div>
                <div class="kc-reminder custom-radio-dsgn"><input class="check_css check_css1 custom-radio" name="radio" id="thirtymin" type="radio" (change)="SetReminderValue(2,$event)" value=""><span class="radio-circle"></span>&nbsp;&nbsp;<label class="kc-time kc-form-label" for="thirtymin">30 Minutes</label></div>
                <div class="kc-reminder custom-radio-dsgn"><input class="check_css check_css1 custom-radio" name="radio" id="onehour" type="radio" (change)="SetReminderValue(3,$event)" value=""><span class="radio-circle"></span>&nbsp;&nbsp;<label class="kc-time kc-form-label" for="onehour">One Hour</label></div>
                <div class="kc-reminder custom-radio-dsgn"><input class="check_css check_css1 custom-radio" name="radio" id="tomorrow" type="radio" (change)="SetReminderValue(4,$event)" value=""><span class="radio-circle"></span>&nbsp;&nbsp;<label class="kc-time kc-form-label" for="tomorrow">Tomorrow</label></div>
              </div>
            </div>
            <div class="bottom_Line_fliter_line"></div>
            <div class="mb-2 mt-2">
              <div class="col-sm-12 pt-1">
                <div class="d-flex justify-content-between">
                  <div class="">
                  </div>

                  <div class="">
                    <button type="submit" class="btn KC_blue_btn mr-2" (click)="SetReminderNotification()">Set Reminder</button>
                    <a class="KC_button_cancel" data-dismiss="modal" (click)="modalRef.hide()">Cancel</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>
    </form>
</ng-template>

<!--RemindMe Popup End-->
<!--[cid]="tempJobid"-->
<ng-template #createjobModalPopup>
    <app-createjob [Page]="Contactpage" [isAddJob]="isAddJob" (closeCreateEditJobsPopUp)="closeCreateEditJobsPopUp()" (GetStandardWorkflowView)="onAddEditJobCallbackFromHeader($event)"></app-createjob>
</ng-template>

<ng-template #quickAddTimelogModalPopup>
  <app-quick-timesheet-entry-popup (closeQuickAddTimesheetEntryPopup)="closeQuickAddTimesheetpopupFromHeader($event)" [sourceComponent]="'headerComponent'"></app-quick-timesheet-entry-popup>
</ng-template>

<ng-template #createclientModalPopup>
  <div class="">
    <app-createclient [tempload]="tempload" (closeCreateclientPopup)="closeCreateclientPopup()" (getclientlistload)="applyClientViewFromHeader($event)"></app-createclient>
  </div>
</ng-template>
<ng-template #createcontactModalPopup>
  <app-createcontact
  [TempContactid]="tempContactid" [tempcontactload]="tempcontactload" (closeCreatecontactPopup)="closeCreatecontactPopup()"></app-createcontact>
  </ng-template>

<!-- SharePoint Developer: Sandesh, Date:21-03-2025 -->
<!-- Create Document -->
<ng-template #CreateDocTemplateModal>
  <div *ngIf="canShowModalPopup == 'createDocTemplate'">
  <app-dms-create-doc (outputParameter)="closeCreateDocTemplateModal()" >
  </app-dms-create-doc>
</div>
</ng-template>
<!-- Create Document -->
<!-- upload document popup -->
<ng-template #globalUploadFilesPopup>
    <app-dms-upload-document [SiteType]="'globalUpload'" [canCallClientListAPI]="true" (cancelClicked)="closeGlobalUploadPopup()" (outputParameter)="closeGlobalUploadPopup($event)"></app-dms-upload-document>
</ng-template>
<!-- upload document popup end -->
 <!-- Add document iManage -->
<ng-template #addImanageDocPopup>
  <app-dms-add-imanage-doc (closeAddImanageDocPopup)="closeAddImanageDocPopupEvent()"></app-dms-add-imanage-doc>
</ng-template>
<!-- Add document iManage end -->
